import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
  },
  getters: {
  },
  mutations: {
    loginUser(state) {
      state.isLoggedIn = true;
    }
  },
  actions: {
  },
  modules: {
  }
})
